import { render, staticRenderFns } from "./EditScreensaver.vue?vue&type=template&id=98dc01b8"
import script from "./EditScreensaver.vue?vue&type=script&lang=ts"
export * from "./EditScreensaver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports